import { Controller } from '@hotwired/stimulus'

const PERIOD_KEYS = [
  'daily', 'weekly', 'monthly', 'pmtd', 'mtd_last_year', 'yearly', 'pytd',
  'selected_period', 'auto_prev_period', 'comparison_period'
]

export default class extends Controller {
  static targets = ['totalCell', 'avgCell', 'totalPrevCell', 'avgPrevCell', 'totalPctCell', 'avgPctCell']

  handleSearch(event) {
    const matched = event.detail.matched
    const table = this.element.querySelector('table[data-all-row-values]')
    if (!table) return

    const allRows = JSON.parse(table.dataset.allRowValues)
    const revenueMode = table.dataset.revenueMode === 'true'
    const compareEnabled = table.dataset.compareEnabled === 'true'

    const matchedIndices = new Set(matched)
    const filteredRows = allRows.filter((_, i) => matchedIndices.has(i))

    this.updateFooter(filteredRows, revenueMode, compareEnabled)
  }

  updateFooter(rows, revenueMode, compareEnabled) {
    const count = rows.length

    const totals = {}
    PERIOD_KEYS.forEach(key => {
      totals[key] = rows.reduce((sum, r) => sum + (r[key] || 0), 0)
    })

    const averages = {}
    PERIOD_KEYS.forEach(key => {
      const raw = count > 0 ? totals[key] / count : 0
      averages[key] = revenueMode ? Math.round(raw * 100) / 100 : Math.round(raw)
    })

    this.totalCellTargets.forEach(td => {
      td.textContent = this.formatVal(totals[td.dataset.col], revenueMode)
    })
    this.avgCellTargets.forEach(td => {
      td.textContent = this.formatVal(averages[td.dataset.col], revenueMode)
    })

    const totalPrev = compareEnabled ? totals.comparison_period : totals.auto_prev_period
    this.totalPrevCellTargets.forEach(td => {
      td.textContent = this.formatVal(totalPrev, revenueMode)
    })

    const avgPrev = compareEnabled ? averages.comparison_period : averages.auto_prev_period
    this.avgPrevCellTargets.forEach(td => {
      td.textContent = this.formatVal(avgPrev, revenueMode)
    })

    this.updatePctCells(this.totalPctCellTargets, totals, totalPrev)
    this.updatePctCells(this.avgPctCellTargets, averages, avgPrev)
  }

  updatePctCells(cells, data, prev) {
    const pcts = {
      mm:     data.pmtd > 0          ? (data.monthly - data.pmtd) / data.pmtd * 100                   : null,
      mtd_ly: data.mtd_last_year > 0 ? (data.monthly - data.mtd_last_year) / data.mtd_last_year * 100 : null,
      yy:     data.pytd > 0          ? (data.yearly - data.pytd) / data.pytd * 100                    : null,
      period: prev > 0               ? (data.selected_period - prev) / prev * 100                     : null,
    }

    cells.forEach(td => {
      const pct = pcts[td.dataset.pct]
      if (pct == null) {
        td.innerHTML = '<span class="text-muted small">—</span>'
      } else {
        const rounded = Math.round(pct * 10) / 10
        const cls = rounded >= 0 ? 'text-success' : 'text-danger'
        const icon = rounded >= 0 ? 'bi-arrow-up' : 'bi-arrow-down'
        const label = rounded >= 0 ? `+${rounded}%` : `${rounded}%`
        td.innerHTML = `<span class="${cls} small"><i class="bi ${icon}"></i> ${label}</span>`
      }
    })
  }

  formatVal(val, revenueMode) {
    if (revenueMode) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      }).format(val || 0)
    }
    return new Intl.NumberFormat('en-US').format(val || 0)
  }
}
